import OnboardingLogin from './OnboardingLogin';
import OnboardingReviu from './OnboardingReviu';
import OnboardingEnviu from './OnboardingEnViu';
import OnboardingEnviuPoC from './OnboardingEnViuPoC';
import OnboardingBase from './OnboardingBase';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';

const parseDate = (dateString) => {
    if (!dateString) return null;

    const parsedDate = new Date(dateString.replace(' ', 'T'));
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export default function Component(props) {
    const router = useRouter();
    const { items } = props;

    // ✅ Si existeix el paràmetre no_onb a la URL, no mostrar cap modal onboarding
    if (router.query.no_onb !== undefined) return null;

    const esOnboardingActiu = (item) => {
        if (!item.actiu) return false;

        const dataActual = new Date();

        const dataInici = parseDate(item.dataPublicacio);
        const dataFi = parseDate(item.dataDespublicacio);

        const estaActiu = (!dataInici || dataActual >= dataInici) && (!dataFi || dataActual <= dataFi);

        return estaActiu;
    };
    if (!items) return null;
    const onboardingActiu = items.find(esOnboardingActiu);

    if (onboardingActiu) {
        switch (onboardingActiu.tipus) {
            case 'OnboardingEnviu':
                return <OnboardingEnviu {...props} />;
            case 'OnboardingEnviuPoC':
                return <OnboardingEnviuPoC {...props} />;
            case 'OnboardingReviu':
                return <OnboardingReviu {...props} />;
            case 'OnboardingLogin':
                return <OnboardingLogin {...props} />;
            case 'custom':
                return <OnboardingBase onboardingActiu={onboardingActiu} />;
        }
    }
    return null;
}
